import { InfoStep } from '../../../../backend-process/backend-process-presentation/backend-process-presentation.component';
import { ProductsSummaryComponent } from '../../products-summary.component';
import { ChangeDetectionStrategy, Component, computed, effect, inject, input } from '@angular/core';
import { TextNodeType } from '@mwe/models';
import { getAddressGroupFormatted } from '@mwe/utils';

import {
  AddressComponent,
  BasicCardComponent,
  HeadlineComponent,
  HeadlineService,
  InfoboxComponent,
  NextStepsComponent,
  ProductsSummaryInvoiceOldComponent,
  TariffSelectionContainerComponent,
  WizardProductCardComponent,
} from '@mwe/ui/components';
import { TranslateDirective } from '@ngx-translate/core';
import { FormatPhoneNumberPipe } from '@mwe/ui/pipes';

@Component({
  selector: 'mwe-products-summary-redesign-internet',
  templateUrl: './products-summary-redesign-internet.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [HeadlineService],
  imports: [
    AddressComponent,
    HeadlineComponent,
    TariffSelectionContainerComponent,
    BasicCardComponent,
    WizardProductCardComponent,
    TranslateDirective,
    InfoboxComponent,
    ProductsSummaryInvoiceOldComponent,
    FormatPhoneNumberPipe,
    NextStepsComponent,
  ],
})
export class ProductsSummaryRedesignInternetComponent extends ProductsSummaryComponent {
  protected readonly headlineService = inject(HeadlineService);

  headlineReference = input<TextNodeType>('h2');
  isSummaryProductsFromWevTitleVisible = input<boolean>(false);
  infoSteps = input<InfoStep[]>([]);

  readonly formattedAddressC = computed(() => getAddressGroupFormatted(this.address(), true));
  override readonly formattedAddress = computed(() => getAddressGroupFormatted(this.address()));

  constructor() {
    super();
    effect(() => {
      this.headlineService.setReferenceHeadline(this.headlineReference());
    });
  }
}
